// app/windows/FormationContent.tsx
export function FormationContent() {
  return (
    <>
      <p className="mt-1 text-justify">
        Informations sur les formations. 
        page en construction!
      </p>
    </>
  );
}
